export default class TaxiTakeOrderDto {
  orderId: number;
}
